import type { BoatShape } from './boat.js';
import type { PetType, CatColor } from './pets.js';

const PROFILE_KEY = 'sailing.profile.v1';

export interface SavedProfile {
  hullColor: number;
  boatShape: BoatShape;
  shirtColor: number;
  hairStyle: number;
  hairColor: number;
  name: string;
  pet: PetType | null;
  pet2: PetType | null;
  catColor: CatColor;
}

/** Appearance only — chests, inventory, and hunger are session-local and
 *  intentionally don't persist. */
export function loadProfile(): SavedProfile | null {
  try {
    const raw = localStorage.getItem(PROFILE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as SavedProfile;
  } catch {
    return null;
  }
}

export function saveProfile(p: SavedProfile): void {
  try {
    localStorage.setItem(PROFILE_KEY, JSON.stringify(p));
  } catch {
    // Storage unavailable (private browsing, quota, etc.) — not worth surfacing.
  }
}
